import React from "react";
import LayoutMain from "../../../components/Layout/Main/Main";
import LeftSidedImageCopyItemCollection from "../../../Partials/LeftSidedImageCopyItem/collection";
import ProjectImageDatePageCollection from "../../../Partials/ProjectImageDetailPage/Collection";
import BannerWithButton from "../../../Partials/BannerWithButton/index";

const leftSidedImageCopyItemCollectionData = [
  {
    description: [
      "This generous family garden has been brought up to date with a simple, contemporary material palette of light grey tones and crisp white render. The design incorporates a new cabana created with the addition of sliding and bi-fold doors. This natural extension to the pool area creates multiple entertaining spaces and when combined with a generous lawn area the new garden is now able to cope with the growing needs of a young family.",
      "Dense perimeter planting provides the necessary privacy screening and creates a lush green backdrop. A combination of more traditional and contemporary plantings as well as a small kitchen garden further soften and define key areas.",
    ],
    descriptionContent: (
      <>
        <p>
          <span className="line">
            <b>Services Undertaken</b>
            <br />
            Landscape Architecture
            <br />
            Construction
          </span>
          <b>Design Features</b>
          <br />
          Contemporary
          <br />
          Family
          <br />
          Entertainer
          <br />
          Classic
        </p>
      </>
    ),
    image: "../images/projects/haberfield-1.jpg",
    title: "Haberfield",
  },
];

const projectImageDetailPageCollectionData = [
  {
    dataId : 'a1',
    image : '../images/projects/haberfield-1.jpg',
  },
  {
    dataId : 'a4',
    image : '../images/projects/haberfield-2.jpg',
  },
  {
    dataId : 'a8',
    image : '../images/projects/haberfield-3.jpg',
  },
  {
    dataId : 'a2',
    image : '../images/projects/haberfield-4.jpg',
  },
  {
    dataId : 'a3',
    image : '../images/projects/haberfield-5.jpg',
  },
  {
    dataId : 'a5',
    image : '../images/projects/haberfield-6.jpg',
  },
  {
    dataId : 'a2',
    image : '../images/projects/haberfield-7.jpg'
  },
  {
    dataId : 'a3',
    image : '../images/projects/haberfield-8.jpg'
  },
  {
    dataId : 'a5',
    image : '../images/projects/haberfield-9.jpg'
  },
]

const PageHaberField = () => {
  return (
        <LayoutMain>
          <section className="about-top">
        <div className="container-3">
          <LeftSidedImageCopyItemCollection
            data={leftSidedImageCopyItemCollectionData}
          />
        </div>
      </section>
      <section className="pb-100">
        <div className="container-3">
          <div className="row">
            <ProjectImageDatePageCollection
              data={projectImageDetailPageCollectionData}
            />
          </div>
        </div>
      </section>
      <BannerWithButton />
        </LayoutMain>
        )
};

export default PageHaberField;
